export type OfflineMeasurementClientInfo = {
  measurementUuid: string;
  // shape pasujący do requestu /measurement/client-info (plus pola, które UI czyta z current-info)
  spoutLevel: string;
  kitchenWindowConnectedToTheCountertop: boolean;
  doesTheClientPlanBlindsShutters: boolean;
  preparationOfOpeningsForTripleLayerInstallation: string;
  changeOfOpeningDimensions: string;
  constructionSiteCleanupInvestor: boolean;

  // arrays w formacie, który backend zwraca w current-info
  typeOfInstallationUuids: Array<string | { uuid: string; comment?: string }>;
  typeOfBlindInstallationUuids: Array<string | { uuid: string; comment?: string }>;
  roomListUuids: Array<{ uuid: string; measurement: string | number }>;

  // opcjonalne pola z formularza
  typeOfStars?: string | null;
  starsMeasurement?: string | null;
  kitchenWindowConnectedToTheCountertopMeasurement?: string | null;
  comments?: string | null;

  updatedAt: string;
};

type OfflineMeasurementClientInfoState = Record<string, OfflineMeasurementClientInfo>;

const STORAGE_KEY = 'offlineMeasurementClientInfo';

const readState = (): OfflineMeasurementClientInfoState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as OfflineMeasurementClientInfoState) || {};
  } catch (e) {
    console.error('Error reading offline measurement client info:', e);
    return {};
  }
};

const writeState = (state: OfflineMeasurementClientInfoState) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('Error writing offline measurement client info:', e);
  }
};

export const upsertOfflineMeasurementClientInfo = (info: OfflineMeasurementClientInfo) => {
  const state = readState();
  writeState({
    ...state,
    [info.measurementUuid]: info,
  });
};

export const getOfflineMeasurementClientInfo = (
  measurementUuid: string
): OfflineMeasurementClientInfo | null => {
  const state = readState();
  return state[measurementUuid] || null;
};

export const clearOfflineMeasurementClientInfo = () => {
  writeState({});
};
